import { useEffect, useState } from "react";
import { Activity, ArrowLeft, Menu, X } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";
import { useMotionSettings } from "./MotionSettings";

const routes = [
  { to: "/", label: "HOME", end: true },
  { to: "/journey", label: "JOURNEY" },
  { to: "/training", label: "TRAINING" },
  { to: "/mindset", label: "MINDSET" },
  { to: "/media", label: "MEDIA" }
];

export function SiteHeader() {
  const location = useLocation();
  const { reduced, toggleReduced } = useMotionSettings();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.classList.toggle("athlete-menu-open", menuOpen);
    return () => document.body.classList.remove("athlete-menu-open");
  }, [menuOpen]);

  return (
    <header className="athlete-site-header">
      <a
        className="athlete-academy-return"
        href="/youth/athletes"
        aria-label="返回水球学院的青少年运动员栏目"
        title="返回青少年运动员"
      >
        <ArrowLeft size={18} aria-hidden="true" />
      </a>
      <NavLink className="athlete-site-mark" to="/" aria-label="陈海鲲首页">
        <span>CH</span>
        <small>12</small>
      </NavLink>

      <nav id="athlete-mobile-navigation" className={`athlete-site-nav${menuOpen ? " is-open" : ""}`} aria-label="主导航">
        {routes.map(({ to, label, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) => `athlete-site-nav__link${isActive ? " is-active" : ""}`}
          >
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="athlete-site-tools">
        <button
          className={`athlete-motion-toggle${reduced ? " is-reduced" : ""}`}
          type="button"
          onClick={toggleReduced}
          aria-pressed={reduced}
          aria-label={reduced ? "开启完整动态" : "减少页面动态"}
          title={reduced ? "开启完整动态" : "减少页面动态"}
        >
          <Activity size={17} aria-hidden="true" />
          <span>{reduced ? "MOTION OFF" : "REDUCE MOTION"}</span>
        </button>
        <button
          className="athlete-menu-toggle"
          type="button"
          onClick={() => setMenuOpen((open) => !open)}
          aria-expanded={menuOpen}
          aria-controls="athlete-mobile-navigation"
          aria-label={menuOpen ? "关闭导航" : "打开导航"}
          title={menuOpen ? "关闭导航" : "打开导航"}
        >
          {menuOpen ? <X size={22} aria-hidden="true" /> : <Menu size={22} aria-hidden="true" />}
        </button>
      </div>
    </header>
  );
}
